import type { signal, computed } from '@angular/core'
import { createProxySignalFactory } from './proxy-signal.js'
export type {
	Signal,
	WritableSignal,
	CreateComputedOptions,
	CreateSignalOptions,
} from '@angular/core'

export interface SignalImplementation {
	signal: typeof signal
	computed: typeof computed
}

export let signalImplementation: SignalImplementation | undefined

export function setSignalImplementation(impl: SignalImplementation) {
	signalImplementation = impl
	createProxySignalFactory(signalImplementation)
}
